import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60af1b9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agents-table--cell-wrapper" }
const _hoisted_2 = { class: "agents-table--cell-content" }

import { computed } from 'vue';
import { Agent, Agent_Status } from '@/graphql/codegen/generated/graphql';
import AgentStatusLegend from '@/views/agents/components/agents-table/components/agent-status-legend.vue';
import { AgentStatus, AgentStatusMeta } from '@/views/agents/components/agents-table/types/agents-table.types';
import { useI18n } from 'vue-i18n';
import { useOsService } from '@/services/OsService/OsService';

type AgentStatusMap = AgentStatus | 'Online'; // Online used for display Linux ready type

export default /*#__PURE__*/_defineComponent({
  __name: 'AgentsTableStatusCell',
  props: {
    value: null,
    agentMetadata: null
  },
  setup(__props: any) {

const props = __props as { value: AgentStatus; agentMetadata: Agent['metadata'] }


const { t } = useI18n();
const osService = useOsService();

const isUpdating = computed(() => {
  const status: AgentStatus = props.value;
  return status === Agent_Status.Updating;
});

const isExpired = computed(() => {
  const status: AgentStatus = props.value;
  return status === Agent_Status.Expired;
});

const isStopped = computed(() => {
  const status: AgentStatus = props.value;
  return status === Agent_Status.Stopped;
});

const agentStatus = computed(() => {
  const status: AgentStatus = props.value;

  if (props.agentMetadata?.isIncompatibleVersion) {
    if (isUpdating.value) {
      return status;
    }
    // Offline incompatible agent will display an Offline status instead of incompatible status.
    if (props.agentMetadata?.isOffline) {
      return status;
    }
    return AgentStatusMeta.Incompatible;
  }

  if (props.agentMetadata?.isDuplicateLicense) {
    return AgentStatusMeta.Duplicate;
  }

  if (osService?.isUnix.value && status === Agent_Status.Ready) {
    return t('agentsTable.linuxActionsMenu.status.ready');
  }

  return status;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AgentStatusLegend, {
        value: _unref(agentStatus) as AgentStatusMap
      }, null, 8, ["value"]),
      _createElementVNode("div", {
        class: _normalizeClass([{
          disabled: props.agentMetadata?.isOffline || _unref(isStopped),
          'alert-status': (props.agentMetadata?.isIncompatibleVersion && !props.agentMetadata?.isOffline && !_unref(isUpdating)) || props.agentMetadata?.isDuplicateLicense || _unref(isExpired),
        }, "agents-table--cell-content-status text-Text/text_high"])
      }, _toDisplayString(_unref(agentStatus)), 3)
    ])
  ]))
}
}

})